export const snakeToTitleCase = (str: string): string => {
  if (!str) return "";

  return str
    ?.split("_")
    ?.join(" ")
    ?.replace(/^\w/, (c) => c?.toUpperCase());
};
